var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17086 8.54585C3.94305 8.77366 3.94305 9.14301 4.17086 9.37082C4.39867 9.59862 4.76801 9.59862 4.99582 9.37082L7.50001 6.86661L10.0042 9.37082C10.232 9.59862 10.6014 9.59862 10.8292 9.37082C11.0569 9.14301 11.0569 8.77366 10.8292 8.54585L7.9125 5.62917C7.80309 5.51977 7.65471 5.45831 7.50001 5.45831C7.3453 5.45831 7.19693 5.51977 7.08753 5.62917L4.17086 8.54585Z",
    fill: "#777E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp4);
export default __webpack_public_path__ + "static/media/up4.bf2bb5158967905f8fa9f4c719a885a2.svg";
export { ForwardRef as ReactComponent };